module.exports = __webpack_public_path__ + "static/media/02-banner-06-santa-fe-mobile@2x.d4c46901.jpg";